import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./GovApprovedCouncil.css";

const GovApprovedCouncil = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [title, setTitle] = useState("");
  const [icon, setIcon] = useState(null);
  const [link, setLink] = useState("");

  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleIconChange = (e) => setIcon(e.target.files[0]);
  const handleLinkChange = (e) => setLink(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("councilIcon", icon);
    formData.append("link", link);

    try {
      await axios.post(`${API_BASE_URL}/admin/councils`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      alert("Government Approved Council added successfully!");
      navigate("/all-government-approved-council");
    } catch (error) {
      alert("Failed to add Government Approved Council. Please try again.");
      console.error("Error posting data:", error);
    }
  };

  return (
    <div id="gov-approved-council-main">
      <div className="gov-approved-council-head-nav-btns">
        <h4>Government Approved Council</h4>
        <div className="header-main-btns">
          <button onClick={() => navigate("/government-approved-council")}>
            Gov Approved Council
          </button>
          <button onClick={() => navigate("/all-government-approved-council")}>
            All Gov Approved Council
          </button>
        </div>
      </div>
      <div className="gov-approved-council-inner ">
        <form onSubmit={handleSubmit}>
          <div className="gov-app-input">
            <label>
              <b>Title</b>
            </label>
            <input
              type="text"
              placeholder="Enter Title"
              className="gov-appr-concl-field"
              value={title}
              onChange={handleTitleChange}
              required
            />
          </div>
          <div className="gov-app-input">
            <label>
              <b>Link</b>
            </label>
            <input
              type="text"
              name="officialLink"
              value={link}
              onChange={handleLinkChange}
              placeholder="Enter Link"
              className="gov-appr-concl-field"
            />
          </div>
          <div className="gov-app-input">
            <label>
              <b>Upload Icon</b>
            </label>
            <input
              type="file"
              className="gov-appr-concl-field"
              onChange={handleIconChange}
              required
            />
          </div>
          <div className="new-chapter-form-buttons">
            <button type="submit" className="new-chapter-submit-btn">
              Save
            </button>
            <button
              type="button"
              className="new-chapter-cancel-btn"
              onClick={() => navigate("/government-approved-council")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GovApprovedCouncil;
